/* eslint-disable react-hooks/rules-of-hooks */
import {
    CustomButton,
    CustomCheckbox,
    CustomForm,
    CustomFormItem,
    CustomImage,
    CustomInput,
    CustomMoneyInput,
    CustomNumberInput,
    errorDialog,
    Text,
    useText,
} from '@src/components';
import '@src/styles/cardOrder/cardDetailInformation.scss';
import '@src/styles/balanceUpload/cardListInformation.scss';
import { Collapse, Form, Dropdown, Menu } from 'antd';
import cardIcon from '@src/assets/icons/icon-kart.svg';
import { isGreaterMaximumLoadedAmount, moneyFormat } from '@src/utils/utils';
import iconCard from '@src/assets/icons/icon-card.svg';
import iconSearchWhite from '@src/assets/icons/icon-white-search.svg';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    getLoadBalanceDetailsGetPagedList,
    loadBalanceDetailPriceUpdate,
    setBalanceUploadDetails,
    setDetailTableFilter,
    setSelectedBalanceUploadDetails,
    resetBalanceFilterItems,
    setBalanceNotIncludedCards,
} from '@src/store/slice/balanceUploadDetailSlice';
import { addressGetPagedListByUserQuery } from '@src/store/slice/addressSlice';
import {
    getBalanceUploadById,
    setIsAllSelectedRowKeys,
    setRunTimeTotalPrice,
    setSelectedRowKeys,
} from '@src/store/slice/balanceUploadSlice';
import { setLoadingState } from '@src/store/slice/appSettingsSlice';
import { VirtualizedAndLazyScrollTable } from '@src/components/VirtualizedAndLazyScrollTable';
import { debounce } from 'lodash/function';
import CustomMultiSelect from '@src/components/CustomMultiSelect';
import filterButton from '@src/assets/icons/icn-down-white.svg';
import icnUp from '@src/assets/icons/icn_up.png';
import icnDown from '@src/assets/icons/icn_down.png';
import CustomPagination from '@src/components/CustomPagination';
import iconChevronDown from '@src/assets/icons/chevron-down.svg';
import { VouIdCode } from '@src/store/enums';
import PropTypes from 'prop-types';

const CardListInformation = ({ vouId = VouIdCode.Market, defaultPageSize = 10000 }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const { addressListByUserQuery } = useSelector((state) => state?.address);
    const { selectedCustomer } = useSelector((state) => state?.customer);
    const { maximumLoadedAmount } = useSelector((state) => state?.orderLimits);
    const { balanceUploadDetails, tableProperty, balanceNotIncludedCards } = useSelector(
        (state) => state?.balanceUploadDetail,
    );
    const { currentLoadBalance, selectedRowKeys, isAllSelectedRowKeys } = useSelector(
        (state) => state?.balanceUpload,
    );

    const [realPageSize, setRealPageSize] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isBtnActive, setIsBtnActive] = useState(false);
    const [otherPagedPrice, setOtherPagedPrice] = useState(0);
    const [isGetAddresses, setIsGetAddresses] = useState(false);
    const [exceptSelectedCartCount, setExceptSelectedCartCount] = useState(0);
    const [selectedAddressListReset, setSelectedAddressListReset] = useState(false);
    const [existUserAllPrice, setExistUserAllPrice] = useState();
    const [showPageCount, setShowPageCount] = useState(100);
    const [selectedAndAmountedRows, setSelectedAndAmountedRows] = useState(0);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });
    const isExcelPage = !!(
        currentLoadBalance?.orderProcessType === 3 && currentLoadBalance?.totalCount > 0
    );

    const maximumLoadingLimitMessage = useText('maximumLoadingLimitPerCardIs');
    const amountPlaceholder = useText('amount3');
    const referenceCodePlaceholder = useText('referenceCode2');

    const totalCardCount = useMemo(() => {
        return balanceUploadDetails?.filter((item) => item?.price > 0).length;
    }, [balanceUploadDetails]);
    const sortRef = useRef({
        orderType: '',
        orderByValue: '',
    });

    const handleChange = (e) => {
        try {
            const value = e.target.value;
            if (value === '' || value === 0 || value === '0') setExistUserAllPrice('');
            if (!/^\d+([.,]\d{0,2})?$/.test(value)) return;
            if (Number.parseInt(value, 10) < 1000000) setExistUserAllPrice(value);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(async () => {
        await dispatch(setLoadingState(true));
        await dispatch(
            getLoadBalanceDetailsGetPagedList({
                body: { loadBalanceId: currentLoadBalance?.id, vouId },
                pageNumber: pagination.current,
                pageSize: defaultPageSize,
                sortParams: sortRef.current,
            }),
        );
        await dispatch(setLoadingState(false));
    }, [showPageCount]);

    const setSelectedPrice = async () => {
        try {
            if (existUserAllPrice) {
                await dispatch(setLoadingState(true));
                const selectedCardNumbers = new Set(
                    selectedRowKeys?.map((rowKey) => rowKey.split('balance-upload-')[1]) || [],
                );

                const tempArray = balanceUploadDetails?.map((item) => {
                    if (selectedCardNumbers.has(item.cardNumber)) {
                        return { ...item, price: Number.parseInt(existUserAllPrice, 10) };
                    }
                    return item;
                });

                confirmPriceToSelected(tempArray, selectedCardNumbers);
            }
        } catch (error) {
            console.error(error);
            await dispatch(setLoadingState(false));
        }
    };

    const setSelectedAllPrice = async () => {
        try {
            if (existUserAllPrice) {
                await dispatch(setLoadingState(true));
                await selectAllRowsManuel();
                let tempArray = [];
                balanceUploadDetails?.map((item) => {
                    let tempItem = { ...item };
                    tempItem.price = Number.parseInt(existUserAllPrice, 10);
                    tempArray.push(tempItem);
                });
                confirmPriceToSelected(tempArray);
            }
        } catch (error) {
            console.error(error);
            await dispatch(setLoadingState(false));
        }
    };

    const selectAllRowsManuel = async () => {
        const selectedRowKeys = balanceUploadDetails.map((item) => `balance-upload-${item?.cardNumber}`);
        onRowKeysChange(selectedRowKeys, balanceUploadDetails);
        await dispatch(setBalanceNotIncludedCards([]));
        await dispatch(setIsAllSelectedRowKeys(true));
    };

    const confirmPriceToSelected = async (tempArray, targetCardNumbers) => {
        try {
            let val = existUserAllPrice.toString()?.replaceAll('.', '')?.replace(',', '.');
            let v = val === '' ? 0 : Number.parseFloat(val);
            if (
                isGreaterMaximumLoadedAmount({
                    controlValue: maximumLoadedAmount,
                    price: val,
                })
            ) {
                errorDialog({
                    title: <Text t="error" />,
                    message: maximumLoadingLimitMessage.replaceAll('{amount}', maximumLoadedAmount),
                });
                return;
            }

            const eligibleItems = tempArray.filter(
                (tA) => tA.price > 0 && (!targetCardNumbers || targetCardNumbers.has(tA.cardNumber)),
            );

            const data = {
                price: Number.parseFloat(v),
                idList: eligibleItems.map((tA) => tA.id),
                LoadBalanceId: currentLoadBalance?.id,
                cardNumber: eligibleItems.map((tA) => tA.cardNumber),
                dontReFetch: true,
                customerId: selectedCustomer?.customerId,
            };
            await dispatch(setBalanceUploadDetails(tempArray));
            await dispatch(loadBalanceDetailPriceUpdate(data));
            await dispatch(setLoadingState(false));
        } catch (error) {
            console.error(error);
        }
    };

    const loadBalanceDetailsGetPagedList = useCallback(
        async (data, pageSize) => {
            if (!pageSize) {
                pageSize = realPageSize;
            }
            setRealPageSize(pageSize);
            const product = await dispatch(getBalanceUploadById(currentLoadBalance?.id));
            const activePage = await dispatch(
                getLoadBalanceDetailsGetPagedList({
                    body: { ...data, loadBalanceId: currentLoadBalance?.id, vouId },
                    pageNumber: pagination.current,
                    pageSize: defaultPageSize,
                    sortParams: sortRef.current,
                }),
            );
            const lastCurrentBalanceUploadPaged = activePage?.payload?.data?.items?.reduce(
                (acc, item) => {
                    return acc + item?.price;
                },
                0,
            );
            const lastBalanceUpload = product?.payload?.data?.totalPrice;
            setOtherPagedPrice(lastBalanceUpload - lastCurrentBalanceUploadPaged);
        },
        [currentLoadBalance, realPageSize, pagination, dispatch, showPageCount, vouId, defaultPageSize],
    );

    useEffect(() => {
        (async () => {
            if (addressListByUserQuery.length === 0 && !isGetAddresses) {
                setIsGetAddresses(true);
                await dispatch(
                    addressGetPagedListByUserQuery({
                        pageNumber: 0,
                        pageSize: 0,
                    }),
                );
            }
        })();
    }, [addressListByUserQuery, dispatch, isGetAddresses]);

    const totalPrice = useMemo(() => {
        return balanceUploadDetails?.reduce((prc, item) => {
            return prc + item?.price;
        }, 0);
    }, [balanceUploadDetails]);

    useEffect(async () => {
        try {
            let count = 0;
            selectedRowKeys?.map((item) => {
                try {
                    if (
                        balanceUploadDetails?.filter(
                            (bItem) => bItem.cardNumber === item.split('balance-upload-')[1],
                        )[0]?.price > 0
                    ) {
                        count += 1;
                    }
                } catch (errorx) {
                    console.error(errorx);
                }
            });
            setSelectedAndAmountedRows(count);
        } catch (error) {
            console.error(error);
        }
    }, [selectedRowKeys, totalPrice]);

    useEffect(() => {
        dispatch(setRunTimeTotalPrice(totalPrice));
    }, [totalPrice]);

    useEffect(async () => {
        if (isAllSelectedRowKeys) {
            try {
                const selectedKeys = balanceUploadDetails
                    .filter(
                        (detail) => !balanceNotIncludedCards.some((card) => card.cardNumber === detail.cardNumber),
                    )
                    .map((b) => `balance-upload-${b?.cardNumber}`);
                dispatch(setSelectedRowKeys(selectedKeys));
                if (balanceNotIncludedCards.length == 0) {
                    setExceptSelectedCartCount(0);
                }
            } catch (error) {
                console.error(error);
            }
        }
    }, [balanceUploadDetails]);

    const addUpdatePrice = async (value, record, request = false) => {
        let val = value?.replaceAll('.', '')?.replace(',', '.');
        let v = val === '' ? 0 : Number.parseFloat(val);
        if (record?.price !== v) {
            if (
                isGreaterMaximumLoadedAmount({
                    controlValue: maximumLoadedAmount,
                    price: val,
                })
            ) {
                errorDialog({
                    title: <Text t="error" />,
                    message: maximumLoadingLimitMessage.replaceAll('{amount}', maximumLoadedAmount),
                });
                return;
            }

            const data = {
                price: Number.parseFloat(v),
                idList: [record?.id],
                LoadBalanceId: currentLoadBalance?.id,
                cardNumber: [record?.cardNumber],
                dontReFetch: true,
                customerId: selectedCustomer?.customerId,
            };
            // update BalanceUploadDetails with new price
            const newBalanceUploadDetails = balanceUploadDetails?.map((item) => {
                if (item?.id === record?.id) {
                    return { ...item, price: data.price };
                }
                return item;
            });
            await dispatch(setBalanceUploadDetails(newBalanceUploadDetails));

            await dispatch(setLoadingState(false));
            request && (await dispatch(loadBalanceDetailPriceUpdate(data)));
            await dispatch(setLoadingState(true));
        }
    };
    const onInputChangeDebounce = useCallback(
        debounce(async (value, record) => {
            await addUpdatePrice(value, record, true);
        }, 2000),
        [addUpdatePrice],
    );

    const columns = [
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            align: 'center',
            width: 70,
            render: (_, __, index) =>
                (tableProperty?.currentPage - 1) * tableProperty?.pageSize + index + 1,
        },
        {
            title: useText('nameUpperCase'),
            dataIndex: 'name',
            key: 'name',
            width: 100,
            sorter: (a, b) => a.name.localeCompare(b.name),
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: useText('surnameUpperCase'),
            dataIndex: 'surname',
            key: 'surname',
            width: 100,
            sorter: (a, b) => a.surname.localeCompare(b.surname),
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: useText('referenceCode3'),
            dataIndex: 'refNo',
            key: 'refNo',
            sorter: (a, b) => a.refNo.localeCompare(b.refNo),
            width: 100,
        },
        {
            title: useText('cardNumber4'),
            dataIndex: 'cardNumber',
            key: 'cardNumber',
            sorter: (a, b) => a.cardNumber.localeCompare(b.cardNumber),
            width: 100,
        },
        {
            title: useText('deliveryAddressUpperCase'),
            dataIndex: 'addressName',
            key: 'addressName',
            width: 100,
            sorter: (a, b) => a.addressName.localeCompare(b.addressName),
            sortDirections: ['descend', 'ascend'],
            ellipsis: true,
        },
        {
            title: useText('totalBalanceToBeLoadedVatIncludedUpperCase'),
            dataIndex: 'price',
            key: 'price',
            width: 105,
            align: 'right',
            render: (text, record) => {
                return (
                    <CustomMoneyInput
                        id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-price-moneyInput"
                        value={text}
                        name={`price-${record.cardNumber}`}
                        placeholder={amountPlaceholder}
                        height={36}
                        onBlur={(e) => addUpdatePrice(e.target.value, record)}
                        addUpdatePrice={addUpdatePrice}
                        record={record}
                        onInput={(e) => {
                            onInputChangeDebounce(e.target.value, record);
                        }}
                    />
                );
            },
        },
    ];

    const clickFilter = async () => {
        dispatch(setSelectedRowKeys([]));
        dispatch(setSelectedBalanceUploadDetails([]));

        const values = await form.validateFields();
        let newValues;

        if (values.deliveryCode) {
            newValues = { ...values, addressIdList: [values.deliveryCode] };
        } else {
            newValues = { ...values, addressIdList: values.addressIdList };
        }

        await loadBalanceDetailsGetPagedList(
            values.cardNumber ? { ...newValues, cardNumber: values.cardNumber.toString() } : newValues,
        );
    };

    const clickCleanForm = async () => {
        setIsBtnActive(false);
        form.resetFields();
        setSelectedAddressListReset(true);
        await dispatch(setDetailTableFilter({ body: { loadBalanceId: currentLoadBalance?.id } }));
        await loadBalanceDetailsGetPagedList({});
        await dispatch(resetBalanceFilterItems());
    };

    const onRowKeysChange = (record, data) => {
        setExceptSelectedCartCount(
            tableProperty?.totalCount < 20 ? tableProperty?.totalCount - record.length : realPageSize - record.length,
        );
        dispatch(setSelectedRowKeys(record));
        dispatch(setSelectedBalanceUploadDetails(data));
    };

    const handlePageChange = (page, pageSize) => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            current: page?.current,
        }));
    };

    const onValuesChange = async () => {
        const allValues = await form.getFieldsValue();
        if (
            allValues?.cardNumber?.toString().length > 0 ||
            allValues?.addressIdList?.length ||
            allValues?.deliveryCode?.length > 0 ||
            allValues?.name?.length > 0 ||
            allValues?.referenceNumber?.length > 0 ||
            allValues?.showOnlyPriced ||
            allValues?.surname?.length > 0
        ) {
            setIsBtnActive(true);
            return;
        }
        setIsBtnActive(false);
    };

    const handleTableSortedChange = useCallback(
        async (pagination, filters, sorter, allTable) => {
            const { order, field } = sorter;
            if (!order) {
                sortRef.current = {};
            } else {
                sortRef.current = {
                    OrderType: order === 'ascend' ? 'asc' : 'desc',
                    OrderByValue: field,
                };
            }
            await loadBalanceDetailsGetPagedList({}, allTable?.currentDataSource.length || 30);
        },
        [loadBalanceDetailsGetPagedList],
    );

    const handleTablePaginationChange = useCallback(
        async (pageNumber, pageSize) => {
            await dispatch(setLoadingState(true));
            setPagination((prevPagination) => ({
                ...prevPagination,
                current: pageNumber,
            }));

            await dispatch(
                getLoadBalanceDetailsGetPagedList({
                    body: { loadBalanceId: currentLoadBalance?.id, vouId },
                    pageNumber: pageNumber,
                    pageSize: defaultPageSize,
                    sortParams: sortRef.current,
                }),
            );
            await dispatch(setLoadingState(false));
        },
        [dispatch, showPageCount, vouId, defaultPageSize],
    );

    const onMenuClick = (key) => {
        try {
            setShowPageCount(Number.parseInt(key?.key.toString(), 10));
        } catch (error) {
            console.error(error);
        }
    };

    const addressListForFilterMultiSelect = useMemo(
        () =>
            addressListByUserQuery?.map((item) => {
                return {
                    label: item.addressName,
                    value: item.id,
                };
            }),
        [addressListByUserQuery],
    );

    const clickAddressListMultiSelectChange = async (values) => {
        form.setFieldsValue({ addressIdList: values.map((item) => ({ addressId: item.value })) });
        setSelectedAddressListReset(false);
        setTimeout(async () => {
            await onValuesChange();
        }, 200);
    };

    const menuPlate = () => (
        <Menu onClick={(key) => onMenuClick(key)} className="custom-dropdown-menu">
            <Menu.Item key="100" className="custom-dropdown-item">
                100
            </Menu.Item>
            <Menu.Item key="200" className="custom-dropdown-item">
                200
            </Menu.Item>
            <Menu.Item key="300" className="custom-dropdown-item">
                300
            </Menu.Item>
            <Menu.Item key="400" className="custom-dropdown-item">
                400
            </Menu.Item>
            <Menu.Item key="500" className="custom-dropdown-item">
                500
            </Menu.Item>
        </Menu>
    );

    return (
        <div className="card-list-information">
            <div
                style={{
                    display: 'flex',
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    alignItems: 'center',
                    backgroundColor: '#475569',
                    paddingLeft: 4,
                    paddingRight: 4,
                    borderBottomLeftRadius: isExpanded ? 0 : 8,
                    borderBottomRightRadius: isExpanded ? 0 : 8,
                    width: isExpanded ? '100%' : 200,
                }}
            >
                <button
                    style={{
                        display: 'flex',
                        fontSize: 15,
                        color: '#fff',
                        textAlign: 'right',
                        backgroundColor: 'transparent',
                        padding: 10,
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 20,
                        borderWidth: 0,
                        textDecoration: 'underline',
                    }}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <CustomImage style={{ width: 24 }} src={filterButton} />
                    <Text t="addFilter" />
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                        <CustomImage style={{ width: 24 }} src={isExpanded ? icnUp : icnDown} />
                    </div>
                </button>
            </div>
            {isExpanded && !isExcelPage && (
                <div className="compliments-filter-card-list">
                    <Collapse
                        defaultActiveKey={['1']}
                        className="filter-collapse-card"
                        ghost
                        expandIconPosition="right"
                    >
                        <div>
                            <CustomForm
                                name="filterForm"
                                className="compliments-filter-form"
                                initialValues={{
                                    showOnlyPriced: false,
                                }}
                                onValuesChange={onValuesChange}
                                autoComplete="off"
                                layout={'horizontal'}
                                form={form}
                                id="comp-loadBalanceFilterForm"
                            >
                                <div className="form-item">
                                    <CustomFormItem name="name">
                                        <CustomInput
                                            className="c-form-item"
                                            id="comp-balanceUpload-balanceInformation-cardListInformation-name-input"
                                            placeholder={useText('name')}
                                            height={36}
                                        />
                                    </CustomFormItem>
                                    <CustomFormItem name="surname" className="surname-form-item">
                                        <CustomInput
                                            className="c-form-item"
                                            id="comp-balanceUpload-balanceInformation-cardListInformation-surname-input"
                                            placeholder={useText('surname')}
                                            height={36}
                                        />
                                    </CustomFormItem>

                                    <CustomFormItem name="cardNumber" className="card-number-form-item">
                                        <CustomNumberInput
                                            className="c-form-item"
                                            id="comp-balanceUpload-balanceInformation-cardListInformation-cardNumber-numberInput"
                                            autoComplete="off"
                                            placeholder={useText('cardNumber2')}
                                            height={36}
                                        />
                                    </CustomFormItem>

                                    <CustomFormItem name="referenceNumber" className="reference-code-form-item">
                                        <CustomInput
                                            className="c-form-item"
                                            id="comp-balanceUpload-balanceInformation-cardListInformation-refNo-input"
                                            autoComplete="off"
                                            placeholder={referenceCodePlaceholder}
                                            height={36}
                                        />
                                    </CustomFormItem>
                                    <CustomFormItem name="addressIdList" style={{ display: 'none' }}></CustomFormItem>
                                    <CustomMultiSelect
                                        source={addressListForFilterMultiSelect}
                                        reset={selectedAddressListReset}
                                        onCustomMultiSelectChange={clickAddressListMultiSelectChange}
                                        selectSomeItems={useText('deliveryAddress2')}
                                        className="c-form-item"
                                    />
                                    <div
                                        className="form-footer"
                                        style={{ justifyContent: 'flex-end', alignItems: 'center' }}
                                    >
                                        <CustomFormItem
                                            label={false}
                                            name="showOnlyPriced"
                                            className="footer-form-item"
                                            valuePropName="checked"
                                        >
                                            <CustomCheckbox
                                                id="comp-balanceUpload-balanceInformation-cardListInformation-showOnlyPriced-checkbox"
                                                className="only-amount-check"
                                                style={{ marginTop: 14, marginRight: 20 }}
                                            >
                                                <Text t="showThoseWithAmountEntered" />
                                            </CustomCheckbox>
                                        </CustomFormItem>
                                        <div className="action-buttons">
                                            <CustomButton
                                                id="comp-balanceUpload-balanceInformation-cardListInformation-clear-btn"
                                                className="clear-btn"
                                                onClick={clickCleanForm}
                                            >
                                                <Text t="clean" />
                                            </CustomButton>
                                            <CustomButton
                                                id="comp-balanceUpload-balanceInformation-cardListInformation-search-btn"
                                                disabled={!isBtnActive}
                                                className="search-btn"
                                                onClick={clickFilter}
                                                style={{ backgroundColor: '#334155' }}
                                            >
                                                <CustomImage className="icon-search" src={iconSearchWhite} />{' '}
                                                <Text t="search" />
                                            </CustomButton>
                                        </div>
                                    </div>
                                </div>
                            </CustomForm>
                        </div>
                    </Collapse>
                </div>
            )}
            {!isExcelPage && (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 16,
                        paddingTop: 15,
                    }}
                >
                    <div
                        className="complimenet-exist-users-gray"
                        style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 10 }}
                    >
                        <span className="table-cell-address-or">
                            <Text t="pleaseEnterTheBalanceAmountYouWantTo" />
                        </span>
                        <div style={{ display: 'flex', marginRight: 10, marginLeft: 10 }}>
                            <CustomInput
                                value={existUserAllPrice}
                                onChange={handleChange}
                                placeholder={amountPlaceholder}
                                className="compliment-exist-users-input"
                                type="text"
                                inputMode="decimal"
                                pattern="[0-9]*"
                                onKeyDown={(e) => {
                                    // Sadece rakam, backspace, delete, tab, arrow keys
                                    if (
                                        !/[0-9]/.test(e.key) &&
                                        !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            <div className="compliment-exist-users-inputbox">₺</div>
                        </div>
                        <button onClick={setSelectedPrice} className="compliment-exist-users-run-selected">
                            <Text t="applyToSelected" />
                        </button>
                        <button onClick={setSelectedAllPrice} className="compliment-exist-users-run-all">
                            <Text t="applyToAll" />
                        </button>
                    </div>
                </div>
            )}
            {isExcelPage && currentLoadBalance?.totalCount > 0 && (
                <div className="header-info-container">
                    <img src={iconCard} alt={useText('card')} />
                    <span>
                        {' '}
                        <Text t="total" />
                        <b className={'total-card-count'}>{currentLoadBalance?.totalCount}</b> <Text t="card" />
                    </span>
                </div>
            )}
            {balanceUploadDetails.length > 0 && (
                <div
                    style={{
                        backgroundColor: '#fff',
                        height: 15,
                    }}
                ></div>
            )}
            {balanceUploadDetails.length > 0 && (
                <VirtualizedAndLazyScrollTable
                    rowSelection={
                        isExcelPage
                            ? false
                            : {
                                preserveSelectedRowKeys: true,
                                type: 'checkbox',
                                selectedRowKeys,
                                onChange: (selectedRowKeys, selectedRows) => {
                                    onRowKeysChange(selectedRowKeys, selectedRows);
                                    const unSelectedRows = balanceUploadDetails.filter(
                                        (row) => !selectedRowKeys.includes(`balance-upload-${row?.cardNumber}`),
                                    );
                                    dispatch(setBalanceNotIncludedCards(unSelectedRows));
                                },
                                onSelectAll: async (selected) => {
                                    await dispatch(setIsAllSelectedRowKeys(selected));
                                },
                            }
                    }
                    pagination={false}
                    dataSource={balanceUploadDetails}
                    getDataFunc={loadBalanceDetailsGetPagedList}
                    columnsData={columns}
                    rowKey={(record) => `balance-upload-${record?.cardNumber}`}
                    onChange={handleTableSortedChange}
                />
            )}
            {createPortal(
                <div className="person-information-table-footer balance-list-information-table-footer">
                    <div />
                    <div
                        className="footer-info-container"
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 10 }}
                    >
                        {!isExcelPage && (
                            <div className="footer-info-content">
                                <CustomImage src={cardIcon} />
                                <Text t="total" />
                                <span style={{ color: '#EB1000' }}>{totalCardCount}</span>{' '}
                                <Text t="cardsSelected" />
                            </div>
                        )}
                        <div className="total-amount-title">
                            <Text t="totalBalanceToBeLoadedUpperCaseColon" /> <span>{moneyFormat(totalPrice, true)}</span>
                        </div>
                    </div>
                </div>,
                document.getElementById('custom-sticky-container') || document.createElement('div'),
            )}
        </div>
    );
};

CardListInformation.propTypes = {
    vouId: PropTypes.string,
    defaultPageSize: PropTypes.number,
};

export default CardListInformation;
